import { useRef, useEffect } from 'react';
import useUnmount from './useUnmount.js';

function useResizeObserver(el, callback) {
    const cbRef = useRef(callback);
    cbRef.current = callback;
    const handleResize = (entry) => cbRef.current(entry);
    const observer = useRef(null);
    if (!observer.current) {
        observer.current = new ResizeObserver((entries) => {
            if (entries.length === 1) {
                handleResize(entries[0]);
            }
        });
    }
    useEffect(() => {
        const obs = observer.current;
        if (!obs || !el)
            return;
        obs.observe(el);
        return () => {
            obs.unobserve(el);
        };
    }, [el]);
    useUnmount(() => {
        if (observer.current) {
            observer.current.disconnect();
        }
    });
}

export { useResizeObserver as default };
